// The white section card the Numbers page is built from.
export default function Card({ title, subtitle, action, children }) {
  return (
    <section className="bg-white border border-birdie-green/12 rounded-2xl p-4">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h2 className="font-accent text-base text-birdie-charcoal">{title}</h2>
          {subtitle && <p className="text-xs text-birdie-charcoal/50">{subtitle}</p>}
        </div>
        {action}
      </div>
      <div className="mt-3">{children}</div>
    </section>
  );
}

export function Empty({ children }) {
  return <p className="text-sm text-birdie-charcoal/55">{children}</p>;
}

export function CardAction({ onClick, children }) {
  return (
    <button
      onClick={onClick}
      className="shrink-0 text-xs font-semibold text-birdie-green hover:underline"
    >
      {children}
    </button>
  );
}
